export default "__VITE_ASSET__BFwI8J$R__"